'use strict';

var _ = require('lodash');
var $ = require('jquery');
var PubSub = require('tscom-pubsub');
var template = require('../templates/grid.ejs');

var UserView = require('./user');
var VoteOptionView = require('./vote-option');

var GridView = require('standard-vote/app/scripts/views/grid');

module.exports = GridView.extend({

    render: function() {

        this.$el.html(template({
            length: this.collection.models.length,
            copy: this.cms.get('text').views_nominee_grid
        }));

        var user = new UserView({
            cms: this.cms,
            auth: this.auth
        });

        this.$('.user-wrapper').append(user.render().$el);

        let gridName = '';
        // RUN-4 Depending on number of Contestants we will show different columns
        if ( this.dataLength % 3 === 0 && this.dataLength % 2 === 0 ) {
            // Round One/Two -> 6 contestants
            gridName = 'col-opt-1';
        } else if ( this.dataLength % 2 === 0 ) {
            // Round Three -> 4 contestants
            gridName = 'col-opt-2';
        } else if ( this.dataLength % 3 === 0 ) {
            // Round Four -> 3 contestants
            gridName = 'col-opt-3';
        }

        var el = $('<ul/>').addClass(gridName);

        this.voteOptions = this.voteOptions || [];
        this.removeOptions();

        _.each(this.collection.models, function(value) {

            var option = new VoteOptionView({
                model: value,
                dataLength: this.dataLength,
                cms: this.cms,
                voteOption: this.collection,
                router: this.router
            });

            this.voteOptions.push(option);
            el.append(option.render().$el.css({
                'opacity': 0,
            }));

            // option.renderedToDOM();

        }.bind(this));

        this.$('.voting-grid-options').html(el);

        return this;
    },

    voteLogin: function(e) {
        e.preventDefault();

        var evt = {
            event: 'button_click',
            action: 'login',
        };

        PubSub.trigger('clearPendingVotes');
        PubSub.trigger('route:auth');
        PubSub.trigger('trackGoogle',evt);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/grid.js